/**
 * L'adresse de l'API — deux lignes, et un module à elles seules.
 *
 * ⚑ POURQUOI CE FICHIER EXISTE (15/09/2026). Elles vivaient dans
 * `medardApi.js`, avec le client HTTP. Or `medardApi` importe **axios**, et
 * axios est lourd : toute page qui voulait seulement l'adresse de l'API tirait
 * le client entier derrière elle.
 *
 * C'est arrivé le jour où la page d'attente (`SiteBientot`) est entrée dans le
 * tronc commun — elle fait UN appel, et elle a failli faire voyager axios chez
 * chaque visiteur qui ne verra qu'un blason et un champ. Deux suites de tests
 * l'ont dit tout de suite, à leur manière : « Cannot use import statement
 * outside a module », axios étant servi en ESM.
 *
 * ⚠ Et la tentation était de recopier les deux lignes là-bas. *Deux copies
 * d'une même adresse divergent le jour où l'une des deux déménage* — le défaut
 * que la maison a diagnostiqué sur les huit copies d'un prix dans le livret.
 * D'où ce module : `medardApi` le réexporte, et rien ne se recopie.
 */

// Same-origin by default — the API is served by the same host as the front.
// REACT_APP_BACKEND_URL only when the frontend is hosted separately.
export const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');
export const API = `${BACKEND_URL}/api`;
